<v-app id="app">
    <div class="">
        <nav aria-label="breadcrumb" v-if="breadcrumbList.length !== 0">
            <ol class="n-container mt-5 pr-5" style="display:flex; font-size:14px;">
                <li class="breadcrumb-item" :class="{'active': !breadcrumb.link}"
                    v-for="(breadcrumb, idx) in breadcrumbList" :key="idx">
                    <a @click="routeTo(idx)" v-if="breadcrumb.link">{{$t(breadcrumb.name)}}</a>
                    <a :href="breadcrumb.url" v-if="breadcrumb.url">{{$t(breadcrumb.name)}}</a>
                    <a v-if="!breadcrumb.link && !breadcrumb.url">{{$t(breadcrumb.name)}}</a>
                </li>
            </ol>
        </nav>
        <router-view />
    </div>
</v-app>